import { Observable } from 'rxjs';

export class Notificacoes {
  id: number;
  titulo: string;
  resumo: string;
  url: string;
  dataCriacao: Date;
  idioma: string;
  dataCriacaoFormat: string;;
  dataLeitura: Date;
}

export abstract class NotificacoesData {
  abstract getByUserId(userId): Observable<Notificacoes[]>;
  abstract getNotificacoesNaoLidasByUser(userId): Observable<Notificacoes[]>;
  abstract postMarcarComoLida(notificacaoId: number, userId: number): Observable<any>;
  abstract postMarcarTodasComoLidas(userId: number): Observable<any>;
}
